import { apiService } from './api.service';
import { api_no_token_Service } from './api_no_token.service';

export interface CountryDto {
  id: number;
  name: string;
  code?: string;
  dialCode?: string;
}

export interface CountriesPage {
  items: CountryDto[];
  totalCount: number;
}

class CountriesService {
  async getAll(): Promise<CountryDto[]> {
    const res = await api_no_token_Service.get<CountryDto[]>(`/country`); 
    if ((res as any)?.data && (res as any)?.success !== false) {
      return (res as any).data as CountryDto[];
    }
    return (res as any) as CountryDto[];
  }

  async getPageList(page: number = 1, pageSize: number = 100): Promise<CountriesPage> {
    const res = await apiService.get<CountriesPage>(`/country/GetPageList?page=${page}&pageSize=${pageSize}`);
    if ((res as any)?.items && typeof (res as any)?.totalCount === 'number') {
      return res as unknown as CountriesPage;
    } 
    if ((res as any)?.data?.items) {
      return (res as any).data as CountriesPage;
    }
    return { items: [], totalCount: 0 };
  }

  async getById(id: number): Promise<CountryDto | null> {
    const res = await apiService.get<CountryDto>(`/country/${id}`);
    if ((res as any)?.data && (res as any)?.success !== false) {
      return (res as any).data as CountryDto;
    }
    return (res as any) as CountryDto;
  }
}

export const countriesService = new CountriesService();
export default countriesService;


